import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-set-driver-password-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './set-driver-password-dialog.html',
  styleUrl: './set-driver-password-dialog.css'
})
export class SetDriverPasswordDialog {
  @Input() username: string = '';
  @Input() submitting: boolean = false;

  @Output() closed = new EventEmitter<void>();
  @Output() submit = new EventEmitter<{ password: string }>();

  password: string = '';
  error: string | null = null;
  showPassword: boolean = false;

  constructor(private translate: TranslateService) {}

  onCancel(): void {
    this.closed.emit();
  }

  onSubmit(): void {
    const value = String(this.password || '').trim();
    if (!value) {
      this.error = this.translate.instant('set_password_dialog.password_required');
      return;
    }
    this.error = null;
    this.submit.emit({ password: value });
  }

  toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }
}


